import { CorrespondenceDepartmentFunctionDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadCorrespondenceFunction = createAction(
  '[CorrespondenceFunction] Load CorrespondenceFunction'
);

export const loadCorrespondenceFunctionSuccess = createAction(
  '[CorrespondenceFunction] Load CorrespondenceFunction Success',
  props<{ correspondenceFunction: CorrespondenceDepartmentFunctionDto[] }>()
);

export const loadCorrespondenceFunctionFailure = createAction(
  '[CorrespondenceFunction] Load CorrespondenceFunction Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addCorrespondenceFunction = createAction(
  '[CorrespondenceFunction] Add CorrespondenceFunction',
  props<{ newCorrespondenceFunction: CorrespondenceDepartmentFunctionDto[] }>()
);

export const addCorrespondenceFunctionSuccess = createAction(
  '[CorrespondenceFunction] Add CorrespondenceFunction Success',
  props<{ newCorrespondenceFunction: CorrespondenceDepartmentFunctionDto[] }>()
);

export const addCorrespondenceFunctionFailure = createAction(
  '[CorrespondenceFunction] Add CorrespondenceFunction Failure',
  props<{ error: any }>()
);

/**
 * Update CorrespondenceFunction Collection Actions
 */
export const updateCorrespondenceFunction = createAction(
  '[CorrespondenceFunction] Update CorrespondenceFunction',
  props<{
    updateCorrespondenceFunction: CorrespondenceDepartmentFunctionDto[];
  }>()
);

export const updateCorrespondenceFunctionSuccess = createAction(
  '[CorrespondenceFunction] Update CorrespondenceFunction Success',
  props<{
    updateCorrespondenceFunction: CorrespondenceDepartmentFunctionDto[];
  }>()
);

export const updateCorrespondenceFunctionFailure = createAction(
  '[CorrespondenceFunction] Update CorrespondenceFunction Failure',
  props<{ error: any }>()
);

/**
 * Remove CorrespondenceFunction Collection Actions
 */
export const removeCorrespondenceFunction = createAction(
  '[CorrespondenceFunction] Remove CorrespondenceFunction',
  props<{ ids: string[] }>()
);

export const removeCorrespondenceFunctionSuccess = createAction(
  '[CorrespondenceFunction] Remove CorrespondenceFunction Success',
  props<{ ids: string[] }>()
);

export const removeCorrespondenceFunctionFailure = createAction(
  '[CorrespondenceFunction] Remove CorrespondenceFunction Failure',
  props<{ error: any }>()
);
